import { AgmMap } from '@agm/core';
import { Component, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'venue-contact-card',
  templateUrl: 'venue-contact-card.component.html'
})
export class VenueContactCardComponent implements OnInit {
  @Input() contactCard: any;
  iconValue: boolean;
  @Input() set iconType(s: string) {
    this.iconValue = this.getIconValue(s);
  }

  @ViewChild(AgmMap) public agmMap: AgmMap;
  toggle: boolean;

  public clickMap(event: any) {
    if (this.contactCard != null && this.contactCard.Address != null)
      window.open(this.contactCard.Address.GoogleMapsUrl, '_blank');
  }

  public refreshMap() {
    this.agmMap.triggerResize();
  }

  ngOnInit() {}
  getIconValue(s: string): boolean {
    if (s === 'Venue') {
      return true;
    } else if (s === 'Location') {
      return false;
    } else {
      return true;
    }
  }
}
